import { render } from "./ClientPdf.vue?vue&type=template&id=17cce6a3"
import script from "./ClientPdf.vue?vue&type=script&lang=js"
export * from "./ClientPdf.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__